<template>
<ValidationObserver ref="observer">
  <form ref="add_pko_form" @submit.prevent="addPko">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="startdate" v-slot="{ errors }">
                  <label class="md-form-label">Start Date*</label>
                <md-field class="md-invalid">
                  <md-input type="date" v-model="pko_start_date" required/>
                  <validation-error :errors="apiValidationErrors.pko_start_date" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            <div class="md-layout-item md-small-size-100" style="margin-top:34px;">
              <validation-provider rules="paymentplan" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Payment Plan</label>
                  <md-select v-model="pko_payment_plan_id" required>
                    <md-option v-for="option in options_payment_list" :key="option.value" :value="option.id">
                      {{ option.payment_plan_name }}
                    </md-option>
                  </md-select>
                  <validation-error :errors="apiValidationErrors.pko_payment_plan_id" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="drivername" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Driver Name</label>
                  <md-input v-model="pko_driver_name_text" readonly required/>
                  <md-button style="background-color:green;" class="md-icon-button md-round md-info md-dense" v-on:click="findDriver">
                    <md-icon >search</md-icon>
                  </md-button>
                  <validation-error
                    :errors="apiValidationErrors.pko_driver_name_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>KIP No</label>
                  <md-input v-model="pko_driver_kip_no_text" disabled/>
                  <validation-error
                    :errors="apiValidationErrors.pko_driver_kip_no_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="doorno" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vehicle No</label>
                  <md-input v-model="pko_door_no_text" readonly required/>
                  <md-button style="background-color:green;" class="md-icon-button md-round md-info md-dense" v-on:click="findVehicle">
                    <md-icon >search</md-icon>
                  </md-button>
                  <validation-error
                    :errors="apiValidationErrors.pko_door_no_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Plate No</label>
                  <md-input v-model="pko_plate_no_text" disabled/>
                  <validation-error
                    :errors="apiValidationErrors.pko_plate_no_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="pool" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Pool</label>
                  <md-select v-model="pko_pool" required>
                <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                  {{ option.pool_name }}
                </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pko_pool"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            <div class="md-layout-item md-small-size-100">
              <validation-provider rules="payable" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Total Payable</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="pko_total_payable" required/>
                  <validation-error
                    :errors="apiValidationErrors.pko_total_payable"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-textarea v-model="pko_remark" md-counter="150" maxlength="150" md-autogrow></md-textarea>
                  <validation-error
                    :errors="apiValidationErrors.pko_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        
        
      </md-card-content>
      <modal ref="modalListDriver" class="coba" style="margint-top:40px;">
        <template v-slot:header>
          <div>
            <h3>List Driver</h3>
          </div>
          <md-button class="md-dense md-round md-icon-button" @click="CloseListDriver()"><md-icon>close</md-icon></md-button>
        </template>
        
        <template v-slot:body>
          <list-driver :data_id="$refs.modalListDriver.data"/>
        </template>
      </modal>

      <modal ref="modalListVehicle" class="coba">
        <template v-slot:header>
          <div>
            <h3>List Vehicle</h3>
          </div>
          <md-button class="md-dense md-round md-icon-button" @click="CloseListVehicle()"><md-icon>close</md-icon></md-button>
        </template>
        
        <template v-slot:body>
          <list-vehicle :data_id="$refs.modalListVehicle.data"/>
        </template>
      </modal>

      <md-card-actions style="margin-top:20px;">
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <!-- <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button> -->
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import ListDriver from "@/pages/Dashboard/Fms/Pko/Modal/ListDriver.vue";
import ListVehicle from "@/pages/Dashboard/Fms/Pko/Modal/ListVehicle.vue";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import { Modal } from "@/components";
import Swal from 'sweetalert2';
import ListRolePageVue from '../../Admin/Role/ListRolePage.vue';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('drivername', {
  ...required,
  message: 'Name Field is required'
});
extend('startdate', {
  ...required,
  message: 'Start Date Field is required'
});
extend('paymentplan', {
  ...required,
  message: 'Payment Plan Field is required'
});
extend('pool', {
  ...required,
  message: 'Pool Field is required'
});
extend('payable', {
  ...required,
  message: 'Total Payable Field is required'
});
extend('doorno', {
  ...required,
  message: 'Vehicle No Field is required'
});
  
  export default {
     name: "add-pko",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver, Modal, "list-driver": ListDriver, "list-vehicle": ListVehicle},

    mixins: [formMixin],

    data: () => ({
      pko_start_date: null,
      pko_payment_plan_id: null,
      options_payment_list : null,
      pko_driver_name_text : null,
      pko_driver_kip_no_text : null,
      pko_door_no_text : null,
      pko_plate_no_text : null,
      pko_pool: null,
      pko_remark:null,
      pko_total_payable:null,
      pko_door_id:null,
      pko_type : 1,
      pko_driver_id:null,
      options_pool_list: null
    }),

    created() {
      this.getDataPaymentPlan();
    },

  
    methods: {

      async getDataPaymentPlan(){
        await this.$store.dispatch("fms_payment_plan/list",{filter:{payment_plan_type:1}})
        this.options_payment_list = await this.$store.getters["fms_payment_plan/list"]
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"];
      },


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List PKO' })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },


     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addPko()
          }
        });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    findVehicle(){
      this.$refs.modalListVehicle.openModal()
    },

    modalCloseListVehicle(data){
      console.log(data)
      if(data.id){
       this.pko_door_id = data.id
       this.pko_door_no_text = data.vehicle_door_no
       this.pko_plate_no_text = data.vehicle_plate_no
      }
      this.$refs.modalListVehicle.closeModal()
    },

    CloseListVehicle(){
      this.$refs.modalListVehicle.closeModal()
    },

    findDriver(){
      this.$refs.modalListDriver.openModal()
    },

    modalCloseListDriver(data){
      console.log(data)
      if(data.id){
       this.pko_driver_id = data.id
       this.pko_driver_name_text = data.driver_name
       this.pko_driver_kip_no_text = data.driver_no
      }
      this.$refs.modalListDriver.closeModal()
    },

    CloseListDriver(){
      this.$refs.modalListDriver.closeModal()
    },


    // fungsi add data
      async addPko() {

        const data = {
          type: "fms_pkos",
          pko_start_date: this.pko_start_date,
          pko_type: this.pko_type,
          pko_payment_plant_id: this.pko_payment_plan_id,
          pko_poll: this.pko_pool,
          pko_driver_id: this.pko_driver_id,
          pko_vehicle_id: this.pko_door_id,
          pko_total_payable: this.pko_total_payable,
          pko_remark: this.pko_remark
        }


        try {
        await this.$store.dispatch("fms_pko/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.replace({name: 'List PKO Black Plate'});
          this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
<style lang="scss" scoped>
.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
